'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getCurrentLocale = getCurrentLocale;
exports.getAccountingArea = getAccountingArea;
exports.loadLocale = loadLocale;
exports.translate = translate;
exports.localize = localize;
exports.localizeAsync = localizeAsync;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _configStorage = require('./internal/config-storage');

var _configStorage2 = _interopRequireDefault(_configStorage);

var _event = require('./event');

var _event2 = _interopRequireDefault(_event);

var _keys = require('lodash/keys');

var _keys2 = _interopRequireDefault(_keys);

var _forOwn = require('lodash/forOwn');

var _forOwn2 = _interopRequireDefault(_forOwn);

var _debug = require('debug');

var _debug2 = _interopRequireDefault(_debug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)('linksoft:localize');

var storage = (0, _configStorage2.default)(translate);

// exposed for debugging purpose
window.Resx = storage.get();

var currentLocale = null;

var accountingArea = '';

function getCurrentLocale() {
	try {
		return currentLocale || document.documentElement.lang || 'cs';
	} catch (error) {
		log(error);
		return 'cs';
	}
}

function getAccountingArea() {
	return accountingArea;
}

/**
 * Loads all required localization resources.
 *
 * Usage:
 * import {loadLocale} from 'linksoft/core/localize';
 * // automatic load - loads only required resources
 * loadLocale('cs');
 * // or manually:
 * loadLocale('cs', ['MySpecialModule', 'DropZone']);
 *
 * @param requiredNames Localization resources can be pre-loaded manually by entering names of Resx files.
 * @returns {Promise.<*>}
 */
function loadLocale() {
	var requiredNames = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

	if (requiredNames && requiredNames.forEach) {
		requiredNames.forEach(function (name) {
			return storage.add(name, storage.get(name) || {});
		});
	}
	var types = (0, _keys2.default)(storage.get());
	var locale = getCurrentLocale();
	return fetchLocale(types, locale);
}

function fetchLocale(types, locale) {
	return _jquery2.default.getJSON('/api/Localization/Get?locale=' + locale + '&types=' + types).then(function (json) {
		accountingArea = json.accountingArea;
		(0, _forOwn2.default)(json.values, function (v, k) {
			storage.add(k, createLocalizer(v, k));
			log('Resx.' + k + ' loaded');
		});
		_event2.default.trigger('linksoft.localeLoaded');
	}, function (ex) {
		log('parsing failed', ex);
	});
}

function createLocalizer(values, type) {
	values = values || {};
	var localizeFunc = function localizeFunc(key, tryAccountingArea) {
		if (tryAccountingArea) {
			var aaKey = key + '#' + accountingArea;
			var aaResult = values[aaKey];
			if (aaResult) return aaResult;
		}
		return values[key] || '[' + type + ':' + key + ']';
	};

	(0, _forOwn2.default)(values, function (v, k) {
		var aaIndex = k.indexOf('#');
		var tryAccountingArea = aaIndex >= 0;
		var key = tryAccountingArea ? k.substr(0, aaIndex) : k;
		if (!localizeFunc.hasOwnProperty(key) || tryAccountingArea) {
			// not defined yet or redefining AA property
			Object.defineProperty(localizeFunc, key, {
				enumerable: true,
				configurable: true,
				get: function get() {
					return localizeFunc(key, tryAccountingArea);
				}
			});
		}
	});

	return localizeFunc;
}

function translate(typeAndKey) {
	var parts = typeAndKey.split(':', 2);
	if (parts.length === 2) {
		var type = storage.get(parts[0]);
		if (type) {
			var text = type[parts[1]];
			if (text) return text;
		}
	}
	return typeAndKey;
}

/**
 * High order function that returns localization function for specified resource name.
 *
 * Usage:
 *
 * import localize from 'linksoft/core/localize';
 * const Resx = localize('Common', 'App');
 * console.log(Resx.App.AppName);
 * console.log(Resx.App('AppName'));
 *
 * @param names Names of localization resources to populate.
 */
function localize() {
	for (var _len = arguments.length, names = Array(_len), _key = 0; _key < _len; _key++) {
		names[_key] = arguments[_key];
	}

	return names.filter(function (v, i, a) {
		return a.indexOf(v) === i;
	}) // distinct
	.reduce(function (obj, name) {
		// lazy registration, if already loaded do not set to null
		if (!storage.get(name)) {
			storage.add(name, null);
		}
		// create readonly property which returns named dictionary / Resx from memory storage
		Object.defineProperty(obj, name, { get: function get() {
				return storage.get(name);
			} });
		return obj;
	}, {
		get: translate
	});
}

/**
 *
 * @param names
 * @returns {Promise.<TResult>}
 */
function localizeAsync() {
	for (var _len2 = arguments.length, names = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
		names[_key2] = arguments[_key2];
	}

	return fetchLocale(names, getCurrentLocale()).then(function () {
		return localize(names);
	});
}

exports.default = localize;


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/core/localize.js
// module id = 4
// module chunks = 0 1 2